/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BriefResourceBriefDetail } from './';
import {
    BriefResourceBriefDetailFromJSON,
    BriefResourceBriefDetailFromJSONTyped,
    BriefResourceBriefDetailToJSON,
} from './';
import type { BriefResourceClient } from './';
import {
    BriefResourceClientFromJSON,
    BriefResourceClientFromJSONTyped,
    BriefResourceClientToJSON,
} from './';
import type { BriefResourceProfileDetail } from './';
import {
    BriefResourceProfileDetailFromJSON,
    BriefResourceProfileDetailFromJSONTyped,
    BriefResourceProfileDetailToJSON,
} from './';

/**
 * 
 * @export
 * @interface BriefResource
 */
export interface BriefResource {
    /**
     * 
     * @type {string}
     * @memberof BriefResource
     */
    briefId?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResource
     */
    briefType?: BriefResourceBriefTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof BriefResource
     */
    submissionDateTime?: Date;
    /**
     * 
     * @type {BriefResourceClient}
     * @memberof BriefResource
     */
    client?: BriefResourceClient;
    /**
     * 
     * @type {BriefResourceBriefDetail}
     * @memberof BriefResource
     */
    briefDetail?: BriefResourceBriefDetail;
    /**
     * 
     * @type {BriefResourceProfileDetail}
     * @memberof BriefResource
     */
    profileDetail?: BriefResourceProfileDetail;
}


/**
 * @export
 */
export const BriefResourceBriefTypeEnum = {
    Regular: 'REGULAR',
    Strategy: 'STRATEGY'
} as const;
export type BriefResourceBriefTypeEnum = typeof BriefResourceBriefTypeEnum[keyof typeof BriefResourceBriefTypeEnum];


/**
 * Check if a given object implements the BriefResource interface.
 */
export function instanceOfBriefResource(value: object): value is BriefResource {
    return true;
}

export function BriefResourceFromJSON(json: any): BriefResource {
    return BriefResourceFromJSONTyped(json, false);
}

export function BriefResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefResource {
    if (json == null) {
        return json;
    }
    return {
        
        'briefId': json['briefId'] == null ? undefined : json['briefId'],
        'briefType': json['briefType'] == null ? undefined : json['briefType'],
        'submissionDateTime': json['submissionDateTime'] == null ? undefined : (new Date(json['submissionDateTime'])),
        'client': json['client'] == null ? undefined : BriefResourceClientFromJSON(json['client']),
        'briefDetail': json['briefDetail'] == null ? undefined : BriefResourceBriefDetailFromJSON(json['briefDetail']),
        'profileDetail': json['profileDetail'] == null ? undefined : BriefResourceProfileDetailFromJSON(json['profileDetail']),
    };
}

export function BriefResourceToJSON(value?: BriefResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'briefId': value['briefId'],
        'briefType': value['briefType'],
        'submissionDateTime': value['submissionDateTime'] == null ? undefined : ((value['submissionDateTime']).toISOString()),
        'client': BriefResourceClientToJSON(value['client']),
        'briefDetail': BriefResourceBriefDetailToJSON(value['briefDetail']),
        'profileDetail': BriefResourceProfileDetailToJSON(value['profileDetail']),
    };
}

